function CorporateLayout({ children }) {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-corporate-dark text-corporate-light font-wide">
      <div className="text-center">{children}</div>
    </div>
  );
}

export default CorporateLayout;
